/**
 * Created by MinhQuan on 2/15/2017.
 */

angular.module('common.template.about.popup', ['common.helper', 'pascalprecht.translate', 'taric.model.about']).controller('AboutPopupController',
    function(CONSTANTS, $uibModalInstance, AboutModel){
        var aboutPopupCtrl = this;
        aboutPopupCtrl.init = function(){
            AboutModel.getMetadata().then(function(result){
                aboutPopupCtrl.version = result.version;
            }, function(error){
                //Do nothing if we can not load the version
            });
        };
        aboutPopupCtrl.close = function (){
            $uibModalInstance.dismiss('Close');
        };
});






// WEBPACK FOOTER //
// ./app/common/popup/about/about-popup.js